import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  ScreenAccessLogService,
  ScreenCode,
} from 'src/app/shared/services/screen-access-log/screen-access-log.service';

@Component({
  selector: 'app-bloco-carteira',
  templateUrl: './bloco-carteira.component.html',
  styleUrls: ['./bloco-carteira.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class BlocoCarteiraComponent {
  @Input() exibirCarteiraEmpresas = false;

  @Output() closeCarteira = new EventEmitter<void>();

  private readonly screenAccessLog = inject(ScreenAccessLogService);

  private readonly telasPorRota: Record<string, ScreenCode> = {
    '/empresas/minha-carteira': 'EMPRESA_CARTEIRA',
  };

  constructor(private router: Router) {}

  navigateTo(rota: string): void {
    const tela = this.telasPorRota[rota];
    if (tela) {
      this.screenAccessLog.registrar(tela);
    }

    this.router.navigate([rota]);
    this.closeCarteira.emit();
  }
}